var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmarkStrike = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.307 17.9006L12.1162 15.2092L16 11.9885V17.5496C15.9999 17.6342 15.9771 17.7172 15.9343 17.7888C15.8915 17.8604 15.8304 17.9179 15.758 17.9546C15.6856 17.9912 15.6049 18.0056 15.5251 17.996C15.4453 17.9865 15.3697 17.9534 15.307 17.9006ZM15.7084 6.30753C15.722 6.32187 15.7351 6.33659 15.7479 6.35165L8.01857 12.7613L8.00001 7.05356C7.99956 6.91538 8.02499 6.77846 8.07483 6.65065C8.12467 6.52285 8.19794 6.40668 8.29045 6.3088C8.38295 6.21092 8.49287 6.13326 8.6139 6.08027C8.73494 6.02728 8.8647 6 8.99574 6H15.0043C15.2684 6 15.5216 6.11062 15.7084 6.30753ZM17.6112 6.75514L5.43359 16.8536L6.39109 18.0082L18.5687 7.90978L17.6112 6.75514Z",
  fill: "#333333"
})));
export default SvgBookmarkStrike;